import { Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { CustomizerSettingsService } from '../../../../customizer-settings/customizer-settings.service';
import { AsmService } from '../../../../services/asm/asm.service';
import { TranslocoModule } from '@ngneat/transloco';
import { ScanHistory, Technology } from '../../../../interfaces/asm/models';
import { QueryTechnologiesResponse } from '../../../../interfaces/asm/QueryTechnologiesResponse';

@Component({
  selector: 'app-technologies',
  standalone: true,
  imports: [MatCardModule, TranslocoModule],
  templateUrl: './technologies.component.html',
  styleUrl: './technologies.component.scss'
})
export class TechnologiesComponent {
    // isToggled
    isToggled = false;

    @Input() scan: ScanHistory;
    data: Technology[] = [];

    constructor(
        public themeService: CustomizerSettingsService,
        private asmService: AsmService
    ) {
        this.themeService.isToggled$.subscribe((isToggled) => {
            this.isToggled = isToggled;
        });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    // Dark Mode
    toggleTheme() {
        this.themeService.toggleTheme();
    }

    // changeData
    changeData() {
        this.asmService
            .getQueryTechnologies(this.scan.id)
            .subscribe((response: QueryTechnologiesResponse) => {
                this.data = response.technologies;
            });
    }
}
